import React, { forwardRef, Ref } from 'react';
import ReactSlick from 'react-slick';
import type { Settings } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Using require since the types are causing issues
const Slider = require('react-slick').default;

interface SliderProps extends Omit<Settings, 'ref'> {
  children: React.ReactNode;
}

const SliderWrapper = forwardRef((props: SliderProps, ref: Ref<ReactSlick>) => {
  const { children, ...settings } = props;
  return (
    <Slider ref={ref} {...settings}>
      {children}
    </Slider>
  );
});

SliderWrapper.displayName = 'SliderWrapper';
export default SliderWrapper;
